import './App.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import { CartProvider } from './Context/CartContext';

// PAGES
import HomeIndex from './Components/HomePage/HomeIndex';
import ServiceIndex from './Components/Service/ServiceIndex';
import BlogsIndex from './Components/Blogs/BlogsIndex';
import TermsAndConditionIndex from './Components/TermsAndCondition/TermsAndConditionIndex';
import PrivacyPolicyIndex from './Components/PrivacyandPolicy/PrivacyPolicyIndex';
import AboutUsIndex from './Components/AboutUs/AboutUsIndex';
import PhotoGalleryIndex from './Components/PhotoGallery/PhotoGalleryIndex';
import JoinUsIndex from './Components/JoinUs/JoinUsIndex';
import GetInTouchIndex from './Components/ContactUs/GetInTouchIndex';

import ProductCard from './Components/HomePage/ProductCard';
import PaymentPage from './Components/Payment/PaymentPage';
import PaymentIndex from './Components/Payment/PaymentIndex';
import InvoicePage from './Components/Payment/InvoicePage';

import ProductsIndex from './Products/ProductsIndex';


// 🔝 SCROLL TO TOP COMPONENT
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // remove this line if you want instant scroll
    });
  }, [pathname]);

  return null;
}


// 🔒 PROTECTED ROUTE
const ProtectedRoute = ({ children }) =>
  localStorage.getItem('cart_access')
    ? children
    : <Navigate to="/" replace />;

function App() {
  return (
    <CartProvider>
      <div
        className="App"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >

        {/* 🔝 AUTO SCROLL */}
        <ScrollToTop />

        <Routes>

          {/* PUBLIC */}
          <Route path="/" element={<HomeIndex />} />
          <Route path="/ServiceIndex" element={<ServiceIndex />} />
          <Route path="/BlogsIndex" element={<BlogsIndex />} />
          <Route path="/TermsAndConditionIndex" element={<TermsAndConditionIndex />} />
          <Route path="/AboutUsIndex" element={<AboutUsIndex />} />
          <Route path="/PhotoGalleryIndex" element={<PhotoGalleryIndex />} />
          <Route path="/JoinUsIndex" element={<JoinUsIndex />} />
          <Route path="/GetInTouchIndex" element={<GetInTouchIndex />} />
          <Route path="/PrivacyPolicyIndex" element={<PrivacyPolicyIndex />} />
          <Route path="/ProductCard" element={<ProductCard />} />
          <Route path="/ProductsIndex" element={<ProductsIndex />} />

          {/* 🔒 SECURED */}
          <Route
            path="/PaymentPage"
            element={
              <ProtectedRoute>
                <PaymentPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/PaymentIndex"
            element={
              <ProtectedRoute>
                <PaymentIndex />
              </ProtectedRoute>
            }
          />

          <Route
            path="/InvoicePage"
            element={
              <ProtectedRoute>
                <InvoicePage />
              </ProtectedRoute>
            }
          />

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </div>
    </CartProvider>
  );
}

export default App;